import { writable } from "svelte/store";
import { SessionStorage } from "../support/storage";

type ClientSettings = {
  showWaypoints: boolean;
  timemachine: boolean;
  amPm?: boolean;
  manualLocation?: boolean;
};

export const settings = writable<ClientSettings>({
  showWaypoints: false,
  timemachine: false
  // left blank intentionally to allow override
  // amPm: false,
  // manualLocation: false,
});

function syncSettings(centcomSettings: ClientSettings) {
  settings.update(($settings) => {
    const hydrated = SessionStorage.getItem("settings", {});

    return { ...$settings, ...centcomSettings, ...hydrated };
  });
}

export function initializeSettings(centcomSettings: ClientSettings) {
  const doSync = syncSettings.bind(null, centcomSettings);

  doSync();

  window.addEventListener("storage", doSync);

  return settings.subscribe(($settings) => {
    SessionStorage.setItem("settings", $settings);

    return () => window.removeEventListener("storage", doSync);
  });
}

export function updateSetting(key: string, value: number | string | boolean | null) {
  settings.update((old) => {
    return { ...old, [key]: value };
  });
}

export function resetSettings() {
  SessionStorage.removeItem("settings");
  window.location.reload();
}
